var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.6906C0 6.25947 4.40277 1.85675 9.83383 1.85675H11.875V0.557732C11.875 0.0757924 12.4458 -0.178407 12.804 0.143999L16.5149 3.48384C16.7606 3.70498 16.7606 4.09021 16.5149 4.31134L12.804 7.65119C12.4458 7.97359 11.875 7.71936 11.875 7.23746V5.93878H9.97659C6.07402 5.93878 2.55728 8.29392 1.07135 11.9025C0.839191 12.4663 0 12.3003 0 11.6906H0Z",
    fill: "#83829B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 7.30945C19 12.7405 14.5972 17.1433 9.16615 17.1433H7.12499V18.4423C7.12499 18.9242 6.55417 19.1784 6.19599 18.856L2.48506 15.5162C2.23936 15.295 2.23936 14.9098 2.48506 14.6887L6.19599 11.3488C6.55421 11.0264 7.12499 11.2806 7.12499 11.7625V13.0612H9.02339C12.926 13.0612 16.4427 10.7061 17.9286 7.09749C18.1608 6.53372 19 6.69971 19 7.30945Z",
    fill: "#83829B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlter);
export default __webpack_public_path__ + "static/media/alter.2203c90ba5d819855218746725c137d1.svg";
export { ForwardRef as ReactComponent };